import React, { useContext } from 'react';
import { FinancingSacksHectares } from '@indigo-ag/schema';

import i18next from 'core/i18n';
import { NewPage } from 'core/components';
import { PricingList } from '../../components/PricingList/PricingList';
import { AddNewPricing } from '../../components/AddNewPricing/AddNewPricing';
import { getAllFinancingSacksHectares } from '../../queries';
import { LoadingWrapper, utils, Permissions } from 'shared';
import { UserContext } from 'core/components/GateWay/GateWay';
import { PatrimonyUpload } from 'features/pricing/components/PatrimonyUpload/PatrimonyUpload';

export const PricingManagementPage: React.FunctionComponent = () => {
  /**
   * User Context
   */

  const { hasPermission, isSuper } = useContext(UserContext);
  const isInternal = hasPermission(Permissions.FA_INTERNAL);
  const isCreditLead = hasPermission(Permissions.FA_CREDIT_LEAD);

  const canEdit = isSuper || isInternal || isCreditLead;

  return (
    <NewPage title={utils.text.toTitleCase(i18next.t('pricingManagement'))}>
      {canEdit && (
        <>
          <PatrimonyUpload />
          <AddNewPricing />
        </>
      )}

      <LoadingWrapper query={getAllFinancingSacksHectares}>
        {({ data }: { data: { financingSacksHectares: FinancingSacksHectares[] } }) => {
          return <PricingList sacksHectares={data.financingSacksHectares} editable={canEdit} />;
        }}
      </LoadingWrapper>
    </NewPage>
  );
};
